<button
  #launcherButton
  type="button"
  class="calculator-launcher"
  aria-label="Open normal calculator"
  [attr.aria-pressed]="isOpen()"
  (click)="toggleCalculator()"
  title="Calculator"
>
 <img [src]="imageEnum.CALCULATOR" alt="calculator.svg">
</button>

@if (isOpen()) {
  <section
    #calculatorPanel
    class="calculator-panel"
    [style.left.px]="panelPosition().x"
    [style.top.px]="panelPosition().y"
  >
    <header class="calculator-titlebar" (pointerdown)="startDragging($event)">
      <span class="calculator-title">Normal Calculator</span>

      <div class="calculator-titlebar-actions">
        <button
          type="button"
          class="calculator-titlebar-button calculator-titlebar-button-minimize"
          aria-label="Minimize calculator"
          (click)="closeCalculator()"
        >
          <span></span>
        </button>
        <button
          type="button"
          class="calculator-titlebar-button calculator-titlebar-button-close"
          aria-label="Close calculator"
          (click)="closeCalculator()"
        >
          <span>⊗</span>
        </button>
      </div>
    </header>

    <div class="calculator-body">
      <div class="calculator-display-shell">
        <div class="calculator-expression">
          <span class="calculator-memory">{{ memoryIndicator() }}</span>
          <span>{{ expressionValue() }}</span>
        </div>
      </div>

      <div class="calculator-display-shell">
        <div class="calculator-display">{{ displayValue() }}</div>
      </div>

      <div class="calculator-memory-grid">
        @for (button of memoryButtons; track button.label) {
          <button
            type="button"
            class="calculator-key calculator-key--memory"
            (click)="handleButtonClick(button)"
          >
            {{ button.label }}
          </button>
        }
      </div>

      <div class="calculator-keypad">
        @for (row of keypadRows; track $index; let rowIndex = $index) {
          <div
            class="calculator-keypad-row"
            [class.calculator-keypad-row--actions]="rowIndex === 0"
            [class.calculator-keypad-row--equals-host]="rowIndex === 3"
            [class.calculator-keypad-row--final]="rowIndex === 4"
          >
            @for (button of row; track button.label) {
              <button
                type="button"
                [class]="getButtonClasses(button)"
                (click)="handleButtonClick(button)"
              >
                {{ button.label }}
              </button>
            }
          </div>
        }
      </div>
    </div>
  </section>
}
